<template>
  <div class="button-wrapper">
    <button
      :class="[
        {
          'memory-pad--clear': clearMode
        },
        memoryNrClass
      ]"
      class="memory-pad ripple"
      @click="setMemory()"
    >
      M{{ memoryNr }}
      <span
        :class="{ used: memoryExists, 'is-active': isActive }"
        class="memory-pad__value"
      >
      </span>
      <span
        v-if="memoryExists"
        :class="{ used: memoryExists }"
        class="memory-pad__count"
      >
        {{ memoryCount }}
      </span>
    </button>
    <transition name="fade">
      <p v-if="showMessage" class="memory-pad__message" mode="out-in">
        {{ message }}
      </p>
    </transition>
  </div>
</template>

<script>
export default {
  name: "MemoryPad",
  props: {
    memoryNr: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      memoryExists: false,
      message: "",
      showMessage: false
    };
  },
  computed: {
    isActive() {
      return this.$store.getters.getMemoryActive(this.memoryNr);
    },
    clearMode() {
      return this.$store.state.config.clearMode;
    },
    memoryNrClass() {
      return "memory-pad--" + this.memoryNr; // Add pad number for animation purposes
    },
    memoryCount() {
      if (this.$store.getters.countVideos(this.memoryNr) !== 0) {
        return this.$store.getters.countVideos(this.memoryNr);
      } else {
        return "";
      }
    }
  },
  methods: {
    setMemory() {
      // Clear mode will clear current memoryPad, else add current video in memory
      if (this.clearMode) {
        if (this.memoryExists) {
          this.$store
            .dispatch("clearMemory", this.memoryNr)
            .then(message => {
              this.checkMemory();
              this.setMessage(message);
            })
            .then(() => this.$store.commit("initializeStore")); // Make sure we have the correct values
        }
      } else {
        this.$store
          .dispatch("saveVideo", this.memoryNr)
          .then(message => {
            this.checkMemory();
            this.setMessage(message);
          })
          .then(() => this.$store.commit("initializeStore")); // Make sure we have the correct values
      }
    },
    checkMemory() {
      localStorage.getItem("memory" + this.memoryNr)
        ? (this.memoryExists = true)
        : (this.memoryExists = false);
    },
    setMessage(message) {
      // Temporarily show a feedback message
      if (message !== "") {
        this.message = message;
        this.showMessage = !this.showMessage; // Show message
        setTimeout(() => {
          this.showMessage = !this.showMessage; // Hide message after timeout
          // this.message = ""; // Remove message after timeout
        }, 1500);
      }
    }
  },
  mounted() {
    this.checkMemory();
  }
};
</script>

<style scoped lang="scss">
@import "../partials/vars";

.button-wrapper {
  position: relative;
  width: 30%;
  @media (min-width: $break-small) {
    width: 23%;
  }
}

.memory-pad {
  @include btn;
  position: relative;
  font-size: 15px;
  padding-top: 6px;
  margin: 6px 1%;
  height: 40px;
  font-weight: 700;
  color: #fff;
  background-color: $color-gray-d;

  &--set {
    animation: colorPulseSet 0.4s infinite alternate;
  }

  &--clear {
    animation: colorPulseClear 0.4s infinite alternate;
  }

  @for $i from 1 through 4 {
    &--#{$i} {
      animation-delay: #{$i/20}s;
    }
  }

  &.active,
  &:hover {
    background-color: $color-gray-dd;
  }

  &:focus {
    outline: none;
  }

  &__value {
    right: 0;
    bottom: 0;
    border-radius: 5px;
    margin-right: 4px;
    margin-bottom: 2px;
    padding: 5px;
    display: block;
    position: absolute;
    font-weight: normal;
    font-style: italic;
    font-size: 12px;
    background-color: $color-gray-l;
    &.used {
      background-color: $color-accent;
      &.is-active {
        animation: colorPulseActive;
        animation-duration: 0.4s;
        animation-iteration-count: 5;
        background-color: $color-active;
      }
    }
  }

  &__count {
    left: 0px;
    bottom: 0;
    padding: 14px 7px 0 5px;
    -webkit-box-shadow: inset 1px gray;
    box-shadow: inset 1px gray;
    display: block;
    position: absolute;
    font-weight: 700;
    font-style: normal;
    font-size: 12px;
    color: white;
    background-color: #ccc;
    height: 100%;
  }

  &__message {
    display: block;
    background-color: $color-salmon;
    border-radius: 5px;
    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.3);
    position: absolute;
    bottom: 35px;
    padding: 5px 10px;
    left: -8px;

    &:after {
      content: "";
      position: absolute;
      display: block;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 15px 10px 0 10px;
      border-color: $color-salmon transparent transparent transparent;
    }
  }
  // Animations

  @keyframes colorPulseSet {
    0% {
      background-color: $color-gray-l;
    }
    100% {
      background-color: $color-gray-green;
    }
  }

  @keyframes colorPulseClear {
    0% {
      background-color: $color-gray-red;
    }
    100% {
      background-color: $color-gray-l;
    }
  }

  @keyframes colorPulseActive {
    0% {
      background-color: $color-neutral;
    }
    100% {
      background-color: $color-active;
    }
  }
}
.fade-enter-active {
  animation: fade 0.2s ease-out;
}
.fade-leave-active {
  animation: fadeAway 0.5s;
}

@keyframes fade {
  0% {
    opacity: 0;
    bottom: 110px;
  }
  80% {
    bottom: 50px;
    opacity: 0.8;
  }
  100% {
    opacity: 1;
    bottom: 35px;
  }
}

@keyframes fadeAway {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>
